<template>
  <b-image
    :src="src"
    image-class="snapshot bg-light w-100 cursor-pointer"
    @click="showLargeImage = !showLargeImage"
    fit="cover"
    :max-height="showLargeImage ? undefined : 180"
    auto-size
  />
</template>

<script>
import BImage from "@/components/common/BImage.vue";

export default {
  components: {BImage},
  props: {
    src: String,
    collapsedHeight: {
      type: Number,
      default: 180
    }
  },
  data() {
    return {
      showLargeImage: false
    };
  }
}
</script>
